import * as graphql from 'generated/graphql';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SidebarSectionHeader from './SectionHeader';
import { Sidebar, Skeleton } from '@treams/treams-ui';
import { useModalLink } from 'navigation/ModalNavigation';
import moment from 'moment';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { Box } from 'reflexbox';

function JobPosition(props: { position: graphql.JobPosition }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	return (
		<Sidebar.Item
			path={useModalLink(`/job-positions/${props.position.id}`)}
			title={
				props.position.jobLevel
					? `${localize(props.position.jobTitle.title).text} - ${
							localize(props.position.jobLevel.title).text
					  }`
					: localize(props.position.jobTitle.title).text
			}
			subtitle={`${moment(props.position.startDate).format('MMMM YYYY')} –
        ${
					props.position.endDate
						? moment(props.position.endDate).format('MMMM YYYY')
						: t('conversation.sidebar.jobs.current.title')
				}`}
			small
		/>
	);
}

export default function SidebarJobsSection(props: { user: graphql.User }) {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<SidebarSectionHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
				{t('conversation.sidebar.jobs.title')}
			</SidebarSectionHeader>
			{isOpen && (
				<Box>
					{!props.user.jobPositions && (
						<Skeleton.Repeat count={3}>
							<Sidebar.Item.Skeleton />
						</Skeleton.Repeat>
					)}
					{props.user.jobPositions.map((position) => (
						<JobPosition key={position.id} position={position} />
					))}
				</Box>
			)}
		</>
	);
}
